import { http } from './http'

const BASIC_AUTH = 'Basic YWRtaW46R2VubG9naW5AMTIzNTIx'

// POST /user/proxies
// Body:
// {
//   country_code: string,
//   label: string,
//   password: string,
//   provider_peer_id: string,
//   username: string
// }
export async function createUserProxy (payload) {
  try {
    const res = await http.post('/api/v1/user/proxies', payload)
    return res.data
  } catch (e) {
    const status = e && e.response && e.response.status
    // fallback if backend mounts without /api/v1
    if (status === 404) {
      const res2 = await http.post('/user/proxies', payload)
      return res2.data
    }
    throw e
  }
}

// GET /api/v1/user/sessions
// Query: { limit, offset }
// Response: { limit, offset, sessions: [...], total? }
export async function getAdminProxySummary () {
  const res = await http.get('/api/admin-proxy/summary', {
    params: { exclude_group: 'node' }
  })
  return res.data
}

export async function getAdminProxySummaryNode () {
  const res = await http.get('/api/admin-proxy/summary', {
    params: { group: 'node' }
  })
  return res.data
}

export async function getUserSessions (params) {
  const q = params || {}
  const res = await http.get('/api/v1/user/sessions', {
    params: {
      limit: q.limit,
      offset: q.offset,
      status: q.status || undefined,
      keyword: q.keyword || undefined
    },
    headers: { Authorization: BASIC_AUTH }
  })
  return res.data
}




// WEBPACK FOOTER //
// ./src/api/proxyAdmin.js